const sanitizeNumber = (value?: string | null): string => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};

const getConfiguredNumber = (): string => {
  const configured = typeof import.meta !== 'undefined'
    ? ((import.meta.env?.VITE_WHATSAPP_NUMBER as string | undefined)
      ?? (import.meta.env?.VITE_WHATSAPP_PHONE as string | undefined))
    : undefined;
  return sanitizeNumber(configured);
};

export interface WhatsAppUrlOptions {
  number?: string | null;
  message?: string;
  fallbackToDefault?: boolean;
}

const resolveNumber = (number?: string | null, fallbackToDefault = true): string => {
  const sanitized = sanitizeNumber(number);
  if (sanitized) return sanitized;
  if (!fallbackToDefault) return '';

  return getConfiguredNumber();
};

const buildUrl = (options: WhatsAppUrlOptions = {}): string => {
  const { number, message, fallbackToDefault = true } = options;
  const targetNumber = resolveNumber(number, fallbackToDefault);

  if (!targetNumber) {
    throw new Error('Número do WhatsApp não configurado.');
  }

  const baseUrl = `https://wa.me/${targetNumber}`;
  if (!message) return baseUrl;

  return `${baseUrl}?text=${encodeURIComponent(message)}`;
};

const openChat = (options: WhatsAppUrlOptions = {}): string => {
  const url = buildUrl(options);
  if (typeof window !== 'undefined' && typeof window.open === 'function') {
    window.open(url, '_blank');
  }
  return url;
};

const getDefaultNumber = (): string => resolveNumber(undefined, true);

const formatDisplayNumber = (number?: string | null): string => {
  const sanitized = resolveNumber(number);
  if (!sanitized) return '';

  if (sanitized.length >= 13) {
    const country = sanitized.slice(0, 2);
    const area = sanitized.slice(2, 4);
    const subscriberPart = sanitized.slice(4);
    const firstPart = subscriberPart.slice(0, subscriberPart.length - 4);
    const lastPart = subscriberPart.slice(-4);
    return `+${country} (${area}) ${firstPart}-${lastPart}`;
  }

  if (sanitized.length >= 11) {
    const area = sanitized.slice(0, 2);
    const subscriberPart = sanitized.slice(2);
    const firstPart = subscriberPart.slice(0, subscriberPart.length - 4);
    const lastPart = subscriberPart.slice(-4);
    return `(${area}) ${firstPart}-${lastPart}`;
  }

  return sanitized;
};

export const waService = {
  getConfiguredNumber,
  getDefaultNumber,
  buildUrl,
  openChat,
  sanitizeNumber,
  formatDisplayNumber,
};

export const WhatsAppService = waService;
